module.exports = __webpack_public_path__ + "img/IMG_5082-1200w.323245d7.jpg";